<template>
  <fields-layout
    :tag="tag"
    :gap="gap"
    :gap-before="gapBefore"
    :gap-after="gapAfter"
    :autocomplete="autocomplete ? 'on' : 'off'"
    novalidate
    @keydown.meta.enter="handleSubmit"
    @keydown.ctrl.enter="handleSubmit"
    @submit.prevent="handleSubmit"
  >
    <slot />
  </fields-layout>
</template>

<script>
import FieldsLayout from '../fields-layout/fields-layout.vue';

export default {
  name: 'FormLayout',
  components: { FieldsLayout },
  props: {
    tag: {
      type: String,
      default: 'form'
    },
    gap: FieldsLayout.props.gap,
    gapBefore: FieldsLayout.props.gapBefore,
    gapAfter: FieldsLayout.props.gapAfter,
    disabled: Boolean,
    autocomplete: Boolean
  },
  emits: ['submit'],
  methods: {
    handleSubmit() {
      if (!this.disabled) {
        this.$emit('submit');
      }
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
